import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=5f6601af&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=5f6601af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6601af",
  null
  
)

export default component.exports